import { useEffect } from 'react';

const FormDirtyTracker = ({ dirty, onDirtyChange }) => {
    useEffect(() => {
        onDirtyChange(dirty);
    }, [dirty]);
    return null;
};

export default FormDirtyTracker;
